class TaplifeProfile {
  constructor(
    buildingName,
    localAddress,
    publicAddress,
    accessToken,
    userId,
    isActive,
    serverId
  ) {
    this.id = Math.random().toString().substr(2);
    this.buildingName = buildingName;
    this.localAddress = localAddress;
    this.publicAddress = publicAddress;
    this.userId = userId;
    this.accessToken = accessToken;
    this.isActive = isActive;
    this.serverId = serverId;
    this.modules = undefined; // keep undefined instead of empty array at init, in order to re-fetch from server(will re-fetch only if is not an array).
  }

  static parse(obj) {
    var model = new TaplifeProfile();
    Object.assign(model, obj);
    return model;
  }
}

export default TaplifeProfile;
